import { DelayedActionToastContextType } from "./types";

export const DEFAULT_DELAYED_ACTION_TOAST_CONTEXT: DelayedActionToastContextType = {
    dispatch: () => {},
    toastState: null,
};
